import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    UNDELETE_EXTRAS,
    GET_EXTRAS_SUCCESS,
    UNDELETE_EXTRAS_ERROR,
}
    from "../../../actions/menu/extras";

function* unDeleteExtrasSaga(action) {
    try {
        yield call(extraService.UnDeleteExtras, action.payload)
        yield put({
            type: GET_EXTRAS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_EXTRAS_ERROR,error: error.data
        });
    }
}


export function* unDeleteExtrasSagaWatcher() {
    yield takeLatest(UNDELETE_EXTRAS, unDeleteExtrasSaga);
}